var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"visible":_vm.visible,"title":_vm.title,"can-close":""},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('audio',{ref:"player",attrs:{"src":_vm.link,"controls":""}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }